/*
 * @Author: lubo10 lubo10@hikvision.com.cn
 * @Date: 2023-07-24 14:09:36
 * @LastEditors: lubo10 lubo10@hikvision.com.cn
 * @LastEditTime: 2023-09-08 16:53:38
 * @FilePath: \city-h5\src\utils\chooseImg.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 非微信环境下 原生js获取相册或者拍照
let callbackFunc = null
const chooseImg = (callback) => {
  callbackFunc = callback
  if (!document.getElementById('upload_file')) {
    let div = document.createElement('input')
    div.setAttribute('type', 'file')
    div.style.display = 'none'
    div.setAttribute('id', 'upload_file')
    div.addEventListener('change', fileChange)
    document.body.appendChild(div)
  }
  document.getElementById('upload_file').click()
}

const fileChange = (el) => {
  if (!el.target.files[0].size) return
  fileList(el.target.files)
  el.target.value = ''
}

// 格式限制
const fileList = (files) => {
  for (let i = 0; i < files.length; i++) {
    if(files[i].type=='image/jpeg'||files[i].type=='image/jpg'||files[i].type=='image/png'||files[i].type=='image/webp') {
      fileAdd(files[i])
    } else {
      return
    }
  }
}

// 获取选择的图片的base64地址
const fileAdd = (file) => {
  let reader = new FileReader()
  // reader.vue = this
  reader.readAsDataURL(file)
  // let self = this
  reader.onload = function() {
    file.src = this.result // 图片的base64地址
    const localData = file.src.substring(file.src.indexOf(',') + 1) // 去掉base64头部
    const suffix = file.src.substring(file.src.indexOf('/') + 1, file.src.indexOf(';')) //获取图片类型png
    callbackFunc({ // 回调函数
      fileData: localData,
      suffix: suffix == '/' ? 'jpg' : suffix
    })
  }
}
export default chooseImg
